import type { DischargeReasonApi, UserDischargeApi } from "@/Modules/Customers/Models/Api";
import type { PaginatedApiResponse } from "@/Modules/App/Models/Api/PaginatedApiResponse";

import TherapySideApiService from "@/Services/TherapyApi/utils/TherapyApi";

import { hasValue } from "@/Utils/Objects";

class UserDischargeAPIConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  async getUserDischarge(uuid: string): Promise<UserDischargeApi | undefined> {
    const res = await this.ApiService.get<void, PaginatedApiResponse<UserDischargeApi>>({
      endpoint: `/v1.0/discharge/${uuid}`,
      responseParams: { raw: true },
    });

    if (hasValue(res.body) && res.body.length > 0) return res.body[0];

    return undefined;
  }

  async getReasons(): Promise<DischargeReasonApi[]> {
    return this.ApiService.get<void, DischargeReasonApi[]>({
      endpoint: "/v1.0/discharge/reasons",
    });
  }
}

export default UserDischargeAPIConnector;
